<template>
  <div :class="!embedded ? 'd-flex flex-column flex-nowrap align-content-stretch' : ''">
    <div v-if="!readyToShow">
      <loading>

      </loading>
    </div>
    <div :style="readyToShow ? '' : 'height: 0px; overflow:hidden'">
      <form-header
          :form="form"
          v-if="showHeader && !embedded"
          ref="formHeader"
          :downloadingBrandingZip="downloadingBrandingZip"
          :show-save-edit="mode === 'EDIT' && (!formConfig.restrictedWrite || permissions[formConfig.effectivePermissionWrite] || editEnabledBySecuredFields)"
          :save-enabled="form && form.canSubmit && !readOnlyMode"
          :edit-enabled="editEnabled"
          :save-edit-mode="readOnlyMode ? 'EDIT' : 'SAVE'"
          :show-right-menu="true"
          :showStickyNote="showStickyNote"
          :entityInstance="entityInstance"
          :imagesList="imagesList"
          :listOfImagesInGalleryCard="listOfImagesInGalleryCard"
          :numberOfImages="numberOfImages"
          :formConfig="form"
          :toolbox="toolbox"
          :attachmentsList="attachmentsList"
          :readOnlyMode="readOnlyMode"
          :detailsConfig="detailsConfig"
          :masterId="masterId"
          :mode="mode"
          :translationsEnabled="translationsEnabled"
          :interfaceTranslationsEnabled="interfaceTranslationsEnabled"
          @regionChange="regionChanged"
          @save="save"
          @edit="edit"
          @pin-sticky-note="pinStickyNote"
          @show-audit-log="showAuditLog"
          @show-product-picture="showProductPicture"
          @triggerUpdateGalleryRenderer="updateGalleryOnRenderer"
      >
      </form-header>

      <b-container :fluid="true" v-if="embedded">
        <b-row ref="inputsEmbedded">
        </b-row>
        <b-row v-if="form && form.generalFeedback">
          <b-col>
            <div class="general-feedback" v-if="form && form.generalFeedback">
              <label>{{ form.generalFeedback }}</label>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <v-box :scrollable="true" v-if="!embedded" vb-name="entiEdit">
        <b-container :fluid="true" :style="customStyleForFluidContainer">
          <b-row no-gutters>
            <b-col>
              <b-container class="pt-3">
                <b-row class="p-0">
                  <slot name="form-header-row">
                  </slot>
                </b-row>
                <b-row v-if="formConfig.headerHtml">
                  <b-col :class="formConfig.headerColCssClass" v-html="formConfig.headerHtml">
                  </b-col>
                </b-row>
                <b-row style="margin-right: 0 !important;">
                  <b-col :class="hasLeftDock ? 'p-0 no-gutters ' + dockStyle : ' d-none'">
                    <b-container :fluid="true" class="p-0 m-0 no-gutters">
                      <b-row ref="dockedInput" class="p-0 m-0 no-gutters">
                      </b-row>
                    </b-container>
                  </b-col>
                  <b-col class="p-0 m-0 no-gutters">
                    <b-container :fluid="true" class="p-0 m-0 no-gutters">
                      <b-row ref="inputs">
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>

                <b-row v-if="formConfig.footerHtml">
                  <b-col :class="formConfig.footerColCssClass" v-html="formConfig.footerHtml">
                  </b-col>
                </b-row>
                <b-row v-if="form && form.generalFeedback">
                  <b-col>
                    <div class="general-feedback" v-if="form && form.generalFeedback">
                      <label>{{ form.generalFeedback }}</label>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="p-0">
                  <slot name="form-footer-row">
                  </slot>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </v-box>

      <slot name="footer">
        <FooterNavbar data-test-path="entity-edit-form-footer" v-if="showFooter && showFooterNavbar && !embedded">
          <template v-slot:info>
            <small v-if="entityInstance && isDev" style="font-size: 8px; z-index: 10000">{{ entityInstance.id }}</small>

            <div v-if="entityInstance && pendingTranslations" style="padding-top:6px; width: 100px; text-align: left">
              <font-awesome-icon icon="globe" transform="shrink-2 left-0" class="fa-beat"/>
            </div>
          </template>
          <CloseButton :disabled="saveInProgress || disableClose" :read-only="readOnlyMode"
                       @close="cancel"></CloseButton>

          <FooterButton
              v-if="!readOnlyMode && (!formConfig.restrictedWrite || permissions[formConfig.effectivePermissionWrite])"
              type="Save"
              data-test-path="save-and-close-button"
              :disabled="!form || !form.canSubmit || readOnlyMode || saveInProgress"
              @save="saveAndClose"
              :long-size="true"
              :label=" mode === 'NEW' ? (partiallySavedNew ? RETRY_ADD_AND_CLOSE_LABEL: ADD_AND_CLOSE_LABEL) : SAVE_AND_CLOSE_LABEL"
          >
            <template v-slot:icon>
              <font-awesome-layers>
                <font-awesome-icon icon="caret-left" transform="shrink-0 left-7"/>
                <font-awesome-icon icon="save" transform="shrink-0 right-5 down-0"/>
              </font-awesome-layers>
            </template>
          </FooterButton>
        </FooterNavbar>
      </slot>

      <div ref="inlineTabs" v-if="inlineDetailsTab && inlineDetailsTab.length && inlinesConstructed"
           style="height: 0px; overflow: hidden;">
        <div v-for="tab in inlineDetailsTab" :key="tab.id">
          <details-list
              :class="tab.show ? '' : 'd-none'"
              :masterFormConfig="tab.masterFormConfig"
              :detailsConfig="tab.detail.config"
              :masterId="tab.masterId"
              :has-write-access-to-master="editEnabled"
              :mode="mode"
              :inline-height="tab.detail.config.height"
              :ref="tab.detail.config.detailsClass + ':' + tab.detail.config.joiningField"
              @cancel="cancel"
              :temporaryList="tab.detail.temporaryList"
              :other-changes-to-save="false"
              :show-footer="false"
              detailStyle="inline"
          >

          </details-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import ReachInput from "@/components/inputs/ReachInput";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import {getComponentClass} from "@/components/forms/renderers/Renderers";
import Vue from "vue";
import FormModel from "@/components/forms/FormModel";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import TemporaryList from "@/components/forms/TemporaryList"
import FormHeader from "@/components/forms/FormHeader";
import FormsActions from "@/components/forms/FormsActions";
import ActivityManager from "@/activity/ActivityManager";
import FormsAI from "@/components/forms/FormsAI";
import FormExtensionConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig";
import TemporaryExtension from "@/components/forms/TemporaryExtension";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import DetailsList from "@/components/forms/DetailsList";
import {getMixinComponentClass} from "@/components/forms/mixins/Mixins";
import Loading from "@/components/layout/Loading";
import {LocalNotification, showLocalNotification} from "@/components/notifications/LocalNotification";
import Rpc from "@/Rpc";
import Order from "@/server/com/silkplm/model/plm/Order";
import * as EntityEditFormService from "@/components/forms/customizations/plm/EntityEditFormService";
import {
  checkIfEnabledByFeatureFlags,
  checkIfEnabledByOrganizationFormsSettingsForForm,
  checkIfEnabledByOrganizationFormsSettingsForFormField,
  cloneDataFromAnotherDimensionsTab,
  findEditEnabledFormBySecuredFields,
  findFieldValueFromCompanyCompanyConfigurationFormField,
  findFormOrderForFormField, findGridInlineConfiguration
} from "@/components/forms/customizations/plm/EntityEditFormService";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import RtModule from "@/utils/RtModule";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import featureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import PrintoutManager from "@/PrintoutManager";
import Dimensions from "@/server/com/silkplm/model/plm/Dimensions";
import ClassInfo from "@/components/info/ClassInfo.vue";
import DialogManager from "@/utils/DialogManager";
import {prepareToSendMarkedEntity, resendAttachments} from "@/components/forms/customizations/plm/EntitiesListService";
import MatchedProductsInSeason from "@/server/com/silkplm/model/matching/MatchedProductsInSeason";
import SimilarProductsInSeason from "@/server/com/silkplm/model/matching/SimilarProductsInSeason";
import PPSamplesProduct from "@/server/com/silkplm/model/plm/PPSamplesProduct";
import {getCustomToolboxMixinsForList} from "@/components/forms/ListsMixins";
import PlanningProduct from "@/server/com/silkplm/model/plm/PlanningProduct";
import TechnologicalDetails from "@/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails";
import SessionManager from "@/utils/SessionManager";
import RoutingKeys from "@/server/RoutingKeys";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import InquiryTabCore from "@/server/com/silkplm/model/plm/tabInquiry/InquiryTabCore";
import ComponentIndexProductComponent from "@/server/com/silkplm/model/plm/ComponentIndexProductComponent";
import ApplicationUserOnProductInSeason from "@/server/com/silkplm/model/plm/ApplicationUserOnProductInSeason";

const AuditLog = () => require("@/components/audit-log/AuditLog");

export default {
  name: "EntityEditForm",
  components: {
    Loading,
    DetailsList,
    FormHeader, CloseButton, FooterButton, TextPillsList, VBox, ReachInput, FooterNavbar
  },
  async created() {

    if (window['_mem_bombs']) {

      this.bomb = new ArrayBuffer(23 * 1024 * 1024);
      console.log("Bomb!!!!");
    }

    this.renderers = [];
    this.locations = new Map();

    this.readOnlyMode = this.readOnlyInputs;
    this.modeEditor = this.editorMode;
    this.multicolumn = this.formConfig.allowFormColumns;

    this.setupForm();
  },
  async beforeMount() {

  },

  async beforeDestroy() {
    if (this.form?.onChangeCallback) {
      this.form.onChangeCallback = null;
    }
    //console.log("Clearance");
    if (this.cleanupList) {
      for (const input of this.cleanupList) {
        //console.log("Clearance X");
        input.beforeUnmount?.();
        input.$destroy?.();
        const index = this.$children.indexOf(input);
        if (index > -1) {
          this.$children.splice(index, 1);
        }
        setTimeout(() => {
          try {
            input?.afterUnmount?.();
          } finally {
            setTimeout(() => {
              input.onDestroy?.();
            });
          }
        });
      }
    }
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.$refs.formHeader?.$refs?.editSaveButton) {
        this.$refs.formHeader.$refs.editSaveButton.focus();
      }
    });
    this.setUpWatches();

    let inputsRow = this.embedded ? this.$refs.inputsEmbedded : this.$refs.inputs;
    this.dockedInputRows = this.$refs.dockedInput;
    let floatingContainer = null;
    let floatingRowsLeft = 0;

    if (this.detailsConfig) {
      let fkField = this.detailsConfig.joiningField
      this.fieldsManagedByParent = {};
      this.fieldsManagedByParent[fkField] = {
        hidden: true,
        formDisabledInNew: false,
        formDisabledInEdit: false,
        managedByParent: true
      };
    }
    this.dockStyle = this.formConfig.formDockFlexCss;
    this.formItems = [];
    this.formDockedItems = [];
    this.formConfig.fields.forEach(/** FormFieldConfig */fieldConfig => {
      let fieldFormOrder = findFormOrderForFormField(this.formConfig, fieldConfig);
      if (fieldConfig.docked) {
        this.formDockedItems.push({
          type: "fieldConfig",
          order: fieldFormOrder,
          el: fieldConfig
        });
      } else {
        this.formItems.push({
          type: "fieldConfig",
          order: fieldFormOrder,
          el: fieldConfig
        });
      }
    });
    this.formConfig.mixins.forEach(/** MixinFormComponentConfig */mixinConfig => {
      this.formItems.push({
        type: "mixinConfig",
        order: mixinConfig.formOrder,
        el: mixinConfig
      });
    });

    this.formItems.sort((a, b) => a.order - b.order);
    this.formDockedItems.sort((a, b) => a.order - b.order);
    this.hasLeftDock = this.formDockedItems.length > 0;

    //let i = 0;
    this.formItems.forEach(el => {
      if (el.type === "mixinConfig") {
        [inputsRow, floatingContainer, floatingRowsLeft] = this.attachMixin(el.el, inputsRow, floatingContainer, floatingRowsLeft);
      } else if (el.type === "fieldConfig") {
        //if(i>1){
        //  return;
        //}
        //i++;
        [inputsRow, floatingContainer, floatingRowsLeft] = this.attachField(el.el, inputsRow, floatingContainer, floatingRowsLeft);
      }
    });

    this.formDockedItems.forEach(el => {
      if (el.type === "fieldConfig") {
        [this.dockedInputRows, floatingContainer, floatingRowsLeft] = this.attachField(el.el, this.dockedInputRows, floatingContainer, floatingRowsLeft);
      }
    });

    if (this.embedded) {
      this.$emit('entity-instance-loaded', this.entityInstance);
      if (this.mode === "EDIT") {
        if (this.editAfterStart) {
          this.edit();
        }
      } else {
        this.edit();
      }
      this.markReady();
      return;
    }

    if (this.temporaryInstanceToEdit) {
      this.entityInstance = this.temporaryInstanceToEdit;
      this.pendingTranslations = this.entityInstance?.__supplement__?.translationInProgress;
      await this.form.validate();
      this.edit();
      this.markReady();
      return;
    }

    if (this.mode === "EDIT") {
      if (this.extensionBaseEntityId) {
        let flags = this.extensionConfig.enabledByFeatureFlags;
        if (flags?.length) {
          let enabledExtension = checkIfEnabledByFeatureFlags(flags);
          if (enabledExtension) {
            this.entityInstance = await this.form.loadEntityAsExtension(this.extensionBaseEntityId);
          }
        } else {
          this.entityInstance = await this.form.loadEntityAsExtension(this.extensionBaseEntityId);
        }
      } else {
        this.entityInstance = await this.form.loadEntity(this.entityId);
      }

      this.pendingTranslations = this.entityInstance?.__supplement__?.translationInProgress;

      this.editEnabled = this.form.canEdit();

      this.$emit('entity-instance-loaded', this.entityInstance);
    } else {

      if (this.detailsConfig?.constructorFunction && this.masterEntityInstance) {
        this.entityInstance = await this.form.newEntity((instance) => {
          RtModule()[this.detailsConfig.constructorFunction](this.masterEntityInstance, instance);
        });
      } else {
        this.entityInstance = await this.form.newEntity();
      }
      this.pendingTranslations = this.entityInstance?.__supplement__?.translationInProgress;

      this.edit();
    }

    if (this.inlineDetails && this.inlineDetails.length) {
      this.injectInlines(this.inlineDetails);
    } else {
      this.markReady();
    }

    await this.loadGallery();
    await this.loadAttachments();
    this.setUpHeaderButtons();
    this.editEnabledBySecuredFields = findEditEnabledFormBySecuredFields(this.formConfig, this.permissions);
    this.checkIfTranslationsEnabled();

    let applicationUser = SessionManager.applicationUser;

    if (this.formConfig.formClassLong === PlanningProduct.getRemoteClass() || this.formConfig.formClassLong === PPSamplesProduct.getRemoteClass()) {
      this.$subscribe(RoutingKeys.REFRESH_TABS + "." + applicationUser.id, async message => {
        if (this.sendOfferButton && this.sendAttachmentsButton) {
          this.sendOfferButton.disabled = true;
          this.sendAttachmentsButton.disabled = false;
        }
      });
    }

    this.$subscribe(RoutingKeys.INSERT_COMPONENT_INDEX_FORM + "." + applicationUser.id, async componentIndexId => {
      if (this.formConfig.formClassLong === TechnologicalDetails.getRemoteClass()) {
        await Rpc.plm.services.DictionaryService.createComponentIndexProductComponent(componentIndexId, this.entityInstance.productComponent);
      }
    });

    await this.afterMounted();
  },

  methods: {

    afterMounted() {
      this.$nextTick(() => {
        this.toolbox = EntityEditFormService.filterToolboxButtonsAfterMounted(this.toolbox, this.entityInstance);
      });
    },

    activityClosed() {
      if (this.reopen) {
        this.reopen();
      }
    },
    async close() {
      let res = await ActivityManager.closeTopActivity();
      this.activityClosed?.();
      return res;
    },
    updateGalleryOnRenderer(result) {
      for (let renderer of this.renderers) {
        if (renderer.fieldConfig &&
            renderer.fieldConfig.fieldName === "gallery") {
          renderer.setGalleryData(result);
        }
      }
    },

    checkIfTranslationsEnabled() {
      if (this.formConfig.interfaceTranslation) {
        this.interfaceTranslationsEnabled = true;
        return;
      }
      for (let fieldConfig of this.formConfig.fields) {
        let translationsEnabled = findFieldValueFromCompanyCompanyConfigurationFormField(this.formConfig,
            fieldConfig, 'translations');
        if (translationsEnabled) {
          this.translationsEnabled = true;
        }
      }
    },

    regionChanged(regionCode) {
      this.regionCode = regionCode;
      for (let renderer of this.renderers) {
//    this.fieldConfig?.joinedTranslations;
        let fieldConf = renderer.$props?.fieldConfig;
        if (fieldConf?.joinedTranslations) {
          let validatedField = renderer.$props.validatedField;
        }

        if (renderer.setRegion) {
          renderer.setRegion?.(regionCode);
        }
        renderer.$refs?.input?.setRegion?.(regionCode);
        renderer.$refs?.base?.setRegion?.(regionCode);
        renderer.$refs?.input?.$refs?.base?.setRegion?.(regionCode);
        renderer.$refs?.input?.$refs?.input?.setRegion?.(regionCode);
        renderer.$refs?.base?.$refs?.base?.setRegion?.(regionCode);
        renderer.$refs?.base?.$refs?.input?.setRegion?.(regionCode);
      }
      this.form.setRegion(regionCode);
    },

    setUpHeaderButtons() {
      let lookForAttachments = this.formConfig.fields.find(element => element.fieldName === "attachments");
      let lookForGallery = this.formConfig.fields.find(element => (element.fieldName === "gallery" && !element.formDisabled));

      this.$refs.formHeader?.showOrHideButtons(true, lookForAttachments, lookForGallery, this.isEntityInstance);
    },

    setUpWatches() {
      this.$onUpdate(this.form.formConfig.formClassLong, async (changeEvent) => {
        if (this.form.tag === changeEvent.tag) {
          return;
        }
        showLocalNotification(new LocalNotification($tr('record/TabUpdated', 'Record/Tab updated'),
            this.form.formConfig.formTitle + $tr('hasBennUpdated', ' has been updated'), 5000, false));
        if (!this.readOnlyMode) {
          this.setReadOnly();
        } else if (!this.modeEditor) {
          this.setReadOnly();
        }
        if (this.extensionBaseEntityId) {
          let featureFlags = this.extensionConfig.enabledByFeatureFlags;
          if (featureFlags?.length) {
            let enabledExtension = checkIfEnabledByFeatureFlags(featureFlags);
            if (enabledExtension) {
              this.entityInstance = await this.form.loadEntityAsExtension(this.extensionBaseEntityId);
            }
          } else {
            this.entityInstance = await this.form.loadEntityAsExtension(this.extensionBaseEntityId);
          }
        } else {
          this.entityInstance = await this.form.loadEntity(this.entityId);
        }
        this.pendingTranslations = this.entityInstance?.__supplement__?.translationInProgress;

        this.editEnabled = this.form.canEdit();
      });
    },

    markReady() {
      this.$emit("ready");
      this.$emit("markReadyToShow")
      this.form.refreshVisibilityOfReadOnly().then(() => {
        this.readyToShow = true
      });
    },
    /**
     * @param mixinConfig {MixinFormComponentConfig}
     * @param inputsRow
     * @param floatingContainer
     * @param floatingRowsLeft
     */
    attachMixin(mixinConfig, inputsRow, floatingContainer, floatingRowsLeft) {
      const fieldName = mixinConfig.fieldName.toLowerCase().replaceAll(" ", "");

      if ((!mixinConfig.showInAdd && this.mode === "ADD") || (!mixinConfig.showInEdit && this.mode === "EDIT")) {
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }

      const clazz = getMixinComponentClass(mixinConfig.mixinGroup, mixinConfig.mixinComponentName, this.$router);

      let masterForm = this.masterFormModel ? this.masterFormModel : this.form;
      const input = new clazz({
        propsData: {
          mixinConfig,
          context: this.context,
          mode: this.mode,
          parentForm: this.form,
          editorMode: this.editorMode,
          masterFormModel: masterForm,
        }
      });
      if (!this.cleanupList) {
        this.cleanupList = [];
      }
      this.cleanupList.push(input);

      let div;
      [inputsRow, floatingContainer, floatingRowsLeft, div] = this.mountInput(mixinConfig, input, fieldName, inputsRow, floatingContainer, floatingRowsLeft)
      return [inputsRow, floatingContainer, floatingRowsLeft];
    },

    /**
     * @param fieldConfig {FormFieldConfig}
     * @param inputsRow
     * @param floatingContainer
     * @param floatingRowsLeft
     */
    attachField(fieldConfig, inputsRow, floatingContainer, floatingRowsLeft) {
      const fieldName = fieldConfig.fieldName.toLowerCase().replaceAll(" ", "");

      let enabledFieldBySettings = checkIfEnabledByOrganizationFormsSettingsForFormField(this.formConfig, fieldConfig);
      let enabledFieldByFeatureFlag = checkIfEnabledByFeatureFlags(fieldConfig.enabledByFeatureFlags);
      if (this.fieldsFilter) {
        if (!this.fieldsFilter(fieldConfig)) {
          this.locations.set(fieldName, null);
          return [inputsRow, floatingContainer, floatingRowsLeft];
        }
      }
      if (!enabledFieldBySettings || !enabledFieldByFeatureFlag) {
        this.locations.set(fieldName, null);
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }
      if (fieldConfig.formDisabled || (fieldConfig.formDisabledInEdit && this.mode === "EDIT")
          || (fieldConfig.formDisabledInNew && this.mode === "NEW")) {
        this.locations.set(fieldName, null);
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }

      if (fieldConfig.securedFieldConfig?.restrictedRead &&
          !this.permissions[fieldConfig.securedFieldConfig.effectivePermissionRead] &&
          !this.permissions[fieldConfig.securedFieldConfig.effectivePermissionWrite]
      ) {
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }

      if (fieldConfig.formDisabledInEmbedded && this.embedded) {
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }

      if (fieldConfig.renderer === "CUSTOM_RENDERER") {
        return [inputsRow, floatingContainer, floatingRowsLeft];
      }

      // no children fk when run from parent
      if (this.fieldsManagedByParent && this.fieldsManagedByParent[fieldConfig.fieldName]) {
        let configFromParent = this.fieldsManagedByParent[fieldConfig.fieldName];
        if (configFromParent.managedByParent) {
          this.form.validatedFieldByName(fieldConfig.fieldName).managedByParent = true;
        }
        if (configFromParent.hidden) {
          return [inputsRow, floatingContainer, floatingRowsLeft];
        }
        if (this.mode === "NEW") {
          if (configFromParent.formDisabledInNew) {
            return [inputsRow, floatingContainer, floatingRowsLeft];
          }
        }
        if (this.mode === "EDIT") {
          if (configFromParent.formDisabledInEdit) {
            return [inputsRow, floatingContainer, floatingRowsLeft];
          }
        }
      }

      const clazz = getComponentClass(fieldConfig.renderer, this.$router);
      //console.log(this.formConfig.entityPlural + "==>" + this.masterFormModel?.formConfig?.entityPlural);

      let masterForm = this.masterFormModel ? this.masterFormModel : this.form;
      let validatedField = this.form.validatedFieldsByName.get(fieldConfig.fieldName);
      validatedField.masterFormModel = masterForm;
      validatedField.parentFormModel = this.directParentFormModel;
      const input = new clazz({
        propsData: {
          regionCode: this.regionCode,
          fieldConfig,
          validatedField,
          context: this.context,
          mode: this.mode,
          parentForm: this.form,
          masterFormModel: masterForm,
        }
      });
      if (!this.cleanupList) {
        this.cleanupList = [];
      }
      this.cleanupList.push(input);

      validatedField.renderer = input;
      let div;
      [inputsRow, floatingContainer, floatingRowsLeft, div] = this.mountInput(fieldConfig, input, fieldName, inputsRow, floatingContainer, floatingRowsLeft)

      validatedField.div = div;
      return [inputsRow, floatingContainer, floatingRowsLeft];
    },

    /**
     * @param fieldConfig {MixinFormComponentConfig|FormFieldConfig}
     * @param input}
     * @param fieldName
     * @param inputsRow
     * @param floatingContainer
     * @param floatingRowsLeft
     * @return {(HTMLDivElement|number)[]}
     */
    mountInput(fieldConfig, input, fieldName, inputsRow, floatingContainer, floatingRowsLeft) {

      this.$children.push(input);
      input.$parent = this;
      input.$root = this.$root;
      input.$mount?.();

      input.setEditorMode?.(this.editorMode);

      let cssClazz = "col ";
      if (this.formConfig.allowFormColumns) {
        if (fieldConfig.formColFlexCss) {
          cssClazz += fieldConfig.formColFlexCss;
        } else {
          cssClazz += "col-12 col-md-6";
        }
      } else {
        cssClazz += "col-12";
      }

      let startFloat = false;
      if (fieldConfig.rendererSize.startsWith("col-multirow")) {
        startFloat = true;
      }

      if (fieldConfig.rendererSize === 'row' || fieldConfig.rendererSize === 'multirow') {
        floatingRowsLeft = 0;
        let div = document.createElement("div");
        div.setAttribute("class", "row");
        inputsRow.after(div);
        inputsRow = div;
      }

      let div = document.createElement("div");

      div.setAttribute("class", cssClazz);
      div.dataset.fieldName = fieldName;

      this.locations.set(fieldName, div);

      div.appendChild(input.$el);
      if (input.$el.dataset) {
        input.$el.dataset.testPath = "form-" + fieldName;
      } else {
        div.dataset.testPath = "form-" + fieldName;
      }

      this.renderers.push(input);
      if (floatingRowsLeft > 0 && fieldConfig.rendererSize === 'col') {
        floatingContainer.appendChild(div);
        floatingRowsLeft--;
      } else {
        inputsRow.appendChild(div);
      }
      if (fieldConfig.rendererSize === 'row' || fieldConfig.rendererSize === 'multirow') {
        let div = document.createElement("div");
        div.setAttribute("class", "row");
        inputsRow.after(div);

        inputsRow = div;
      }

      if (startFloat) {
        let container = document.createElement("div");
        container.setAttribute("class", "container px-0");

        let rowDiv = document.createElement("div");
        rowDiv.setAttribute("class", "row px-0");
        container.appendChild(rowDiv);
        let div = document.createElement("div");
        div.setAttribute("class", "col");
        div.appendChild(container);
        inputsRow.appendChild(div);
        floatingContainer = rowDiv;
        floatingRowsLeft = fieldConfig.colMultiRows;
      }

      return [inputsRow, floatingContainer, floatingRowsLeft, div];
    },

    setupForm() {
      try {
        this.hideDeleteByForm = !this.formConfig.showDelete;
        if (this.temporaryInstanceToEdit) {
          this.form = this.temporaryInstanceToEdit.__formModel__;
        } else {
          this.form = new FormModel(this.formConfig, this.presetFields ?? this.context?.presetFields);
          this.form.masterTemporaryList = this.temporaryListToAdd;
          this.form.masterTemporaryExtension = this.temporaryExtensionToSet;
          this.form.baseId = this.extensionBaseEntityId;
        }
        this.form.setContextData(this.contextData);

        this.form.restrictedWrite = this.formConfig.restrictedWrite;
        this.form.permissions = this.permissions;
        this.form.effectivePermissionWrite = this.formConfig.effectivePermissionWrite;
        this.form.effectivePermissionRead = this.formConfig.effectivePermissionRead;
        this.form.restrictedWrite = this.formConfig.restrictedWrite;
        this.form.restrictedRead = this.formConfig.restrictedRead;

        this.form.detailsConfig = this.detailsConfig;
        this.form.extensionConfig = this.extensionConfig;

        this.form.masterId = this.masterId;
        if (this.masterId && this.mode === "NEW" && this.detailsConfig?.joiningField) {
          this.form.validatedFieldByName(this.detailsConfig?.joiningField).value = this.masterId;
          this.form.resetChecksum();
        }
        this.form.masterFormConfig = this.masterFormConfig;
        this.form.directParentFormModel = this.directParentFormModel;
        if (this.directParentFormModel && this.form.formConfig.isExtension) {
          this.directParentFormModel.registerChildExtensionModel(this.form);
        }

        this.form.canSubmitMonitor = () => {
          this.$emit("can-submit-change", this.form);
        }

        this.form.onChangeCallback = () => {
          this.$emit("form-update", this.form);
          this.$emit("unsavedChanges", this.form.unsavedChanges);
        }

        this.form.setFieldsReadOnly(this.readOnlyInputs, this.mode, this.fieldsManagedByParent);

        this.$emit('form-created', this.form);

        this.form.setupWatchers(this);

        setTimeout(async () => {
          this.masterFormModel?.onChangePreValidate(() => {
            this.setInlinesDetailsDisabled();
          });
        });

      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    activateDetails() {
      // if (this.mode == "NEW") {
      //   this.markReady();
      //   return;
      // }


      this.inlinesConstructed = true;
      if (this.entityInstance == null) {
        return;
      }
      this.injectInlines(this.inlineDetails);
    },

    setInlinesDetailsDisabled() {
      for (let tab of this.inlineDetailsTab) {
        const conf = tab?.detail?.config;
        if (conf.visibleFunction) {
          tab.show = RtModule()[conf.visibleFunction].call(this.entityInstance, this.entityInstance,
              this.masterFormConfig, this.masterFormConfig, this.masterFormConfig, null);
        } else {
          tab.show = true;
        }
      }
    },

    buildGridInlines() {
      this.inlineDetailsTab = [];
      if (this.inlineDetails) {
        for (let tab of this.inlineDetails) {
          if (tab.isDetail) {
            if (this.mode === "NEW") {
              if (!tab.detail.config.showInlineInAdd) {
                if (!tab.detail.config.showInlineInAddEnabledByFeatureFlags.length) {
                  continue;
                }
                let enabled = checkIfEnabledByFeatureFlags(tab.detail.config.showInlineInAddEnabledByFeatureFlags);
                if (!enabled) {
                  continue;
                }
              }
            }
          }
          if (tab.masterId === null) {
            tab.masterId = this.form.validatedFieldByName("id").value;
            tab.masterFormConfig = this.formConfig;
            if (this.mode === "NEW" && !tab.detail.temporaryList) {
              tab.detail.temporaryList = this.form.temporaryLists[this.form.makeFieldKey(tab.detail.config)];
              tab.detail.status = this.form.temporaryLists[this.form.makeFieldKey(tab.detail.config)].afterSaveStatus;
            }
          }
          let enabledTabByConfiguration = checkIfEnabledByOrganizationFormsSettingsForForm(tab.detail.config.formConfig.formId);
          if (!enabledTabByConfiguration) {
            continue;
          }
          let enabledTab = checkIfEnabledByFeatureFlags(tab.detail.config.enabledByFeatureFlags);
          if (enabledTab) {
            this.inlineDetailsTab.push(tab);
          }
        }
      }
    },

    injectInlines(inlines) {
      if (this.inlinesInjected) {
        return;
      }

      if (!this.inlinesConstructed) {
        return;
      }
      this.inlinesInjected = true;

      //tab.detail.config.detailsClass + ':' + tab.detail.config.joiningField
      this.buildGridInlines();
      setTimeout(() => {
        // for(let inline of inlines){
        //   inline.masterId = inline.masterIdFun();
        // }
        let refs = this.$refs;
        if (inlines) {
          for (let tab of inlines) {
            if (tab.detail.config.detailsClass === ApplicationUserOnProductInSeason.getRemoteClass()) {
              let x = 5;
            }
            // detailItem.masterFormConfig = this.formConfig;
            let itemId = tab.detail.config.detailsClass + ':' + tab.detail.config.joiningField;
            if (refs[itemId] && refs[itemId][0]) {
              let item = refs[itemId][0];
              let node = item.$el;
              let lastTop = this.$refs.inputs;
              let after = null;
              let maxOrder = -1;
              let fields = [...this.formConfig.fields];
              let fieldsComparator = (field1, field2) => {
                let formFieldOrder1 = findFormOrderForFormField(this.formConfig, field1);
                let formFieldOrder2 = findFormOrderForFormField(this.formConfig, field2);
                return formFieldOrder1 - formFieldOrder2;
              };
              fields.sort(fieldsComparator);
              let eidIndex = _.findIndex(fields, ['fieldName', 'EID']);
              if (eidIndex !== -1) {
                let eidField = fields[eidIndex];
                fields.splice(eidIndex, 1);
                fields.unshift(eidField);
              }
              for (let fld of fields) {
                let fName = fld.fieldName.toLowerCase().replaceAll(" ", "");
                if (this.locations.has(fName) && this.locations.get(fName)) {
                  let fieldFormOrder = findFormOrderForFormField(this.formConfig, fld);
                  if (fieldFormOrder > maxOrder) {
                    maxOrder = fieldFormOrder;
                    let fieldNameInCompanyConfiguration = tab.detail.config.formConfig.originalEntityPlural + " (INLINE)";
                    let tabOrder;
                    let config = findGridInlineConfiguration(this.formConfig, fieldNameInCompanyConfiguration);
                    if (config) {
                      tabOrder = config.formOrder
                    } else {
                      tabOrder = tab.order;
                    }
                    if (maxOrder < tabOrder) {
                      after = fName;
                    }
                  }
                  if (!after) {
                    after = fName;
                  }
                }
              }
              if (after) {
                this.locations.get(after).after(node);
                this.locations.set(after, node);
              } else {
                if (lastTop === this.$refs.inputs) {
                  lastTop.prepend(node);
                } else {
                  lastTop.after(node);
                }
                lastTop = node;
              }
            }
          }
        }
        this.markReady();
      });
      setTimeout(() => {
        this.setInlinesDetailsDisabled();
      })
    },

    insertMixins(mixinsRoot, tab) {
      if (!mixinsRoot) {
        return;
      }

      let lastTop = this.$refs.inputs;
      Array.from(mixinsRoot.children).forEach(node => {
        this.mixinsElements.push(node);
        if (node instanceof Vue) {
          node = node.$el;
        }
        //form-mixin-root="true" :data-after="after" :data-row
        if (!node.dataset.formMixinRoot) {
          return;
        }
        const after = node.dataset.after?.toLowerCase().replaceAll(" ", "");
        const isRow = node.dataset.row === "true";

        if (isRow) {
          node.setAttribute("class", "col-12");
        } else {
          node.setAttribute("class", "col-12 col-md-6");
        }

        if (!after || !this.locations.has(after) || !this.locations.get(after)) {
          if (lastTop === this.$refs.inputs) {
            lastTop.prepend(node);
          } else {
            lastTop.after(node);
          }
          lastTop = node;
          return;
        }

        this.locations.get(after).after(node);
        this.locations.set(after, node);
      });
    },

    async validate() {
      return await this.form.validate();
    },

    cancel() {
      this.$emit('cancel');
    },

    edit(forceCheck = false) {
      if (this.formConfig?.restrictedWrite && !this.permissions[this.formConfig.effectivePermissionWrite]) {
        let editEnabledBySecuredFields = findEditEnabledFormBySecuredFields(this.formConfig, this.permissions);
        if (!editEnabledBySecuredFields) {
          this.form.refreshVisibilityOfReadOnly().then();
          return;
        }
      }
      this.mixinsElements.forEach(value => {
        value?.__vue__?.setReadOnly(false);
      });
      if (this.inlineDetailsTab != null) {
        this.inlineDetailsTab.forEach(value => {
          this.$refs[value.detail.config.detailsClass + ":" + value.detail.config.joiningField][0]?.setReadOnly(false);
        });
      }
      let hasWriteAccess = this.permissions[this.formConfig.effectivePermissionWrite];
      this.renderers.forEach(renderer => {
        if (renderer.fieldConfig) {
          if (this.entityInstance?.__supplement__?.lockedFields) {
            let lockedFields = this.entityInstance.__supplement__.lockedFields;
            for (let lockedField of lockedFields) {
              if (lockedField === renderer.fieldConfig.fieldName) {
                renderer.setReadOnly?.(true);
                return;
              }
            }
          }
          if (renderer.fieldConfig.securedFieldConfig) {
            // let isReadOnly = RtModule()[this.formFieldConfig.readOnlyFunction].call(inst, inst, this.getFormConfig(), this.masterFormModel?.formConfig, this.parentFormModel?.formConfig);
            if (!renderer.fieldConfig.securedFieldConfig.restrictedWrite) {
              renderer.setReadOnly?.(renderer.validatedField.dynReadOnly);
              return;
            } else if (renderer.fieldConfig.securedFieldConfig?.restrictedWrite) {
              if (!this.permissions[renderer.fieldConfig.securedFieldConfig.effectivePermissionWrite]) {
                renderer.setReadOnly?.(true);
                return;
              } else {
                renderer.setReadOnly?.(renderer.validatedField.dynReadOnly);
                return;
              }
            }
          }
          if (renderer.fieldConfig.readOnlyInEdit && this.mode !== "NEW") {
            return;
          }
          if (!this.formConfig.restrictedWrite) {
            renderer.setReadOnly?.(renderer.validatedField.dynReadOnly);
            hasWriteAccess = true;
          } else if (hasWriteAccess) {
            renderer.setReadOnly?.(renderer.validatedField.dynReadOnly);
          }
        } else if (renderer.mixinConfig) {
          renderer.setReadOnly?.(false);
        }
      });

      this.canDelete = this.form.canDelete();

      this.form.setFieldsReadOnly(!hasWriteAccess, this.mode, this.fieldsManagedByParent);
      this.readOnlyMode = false;
      if (forceCheck) {
        this.form.validate(true);
      }
      this.form.refreshVisibilityOfReadOnly().then();
      EntityEditFormService.setEditToolboxButtonAfterEditForm(this.entityInstance, this.toolbox,
          this.permissions[this.formConfig.effectivePermissionWrite]);
    },


    // turnToEdit(masterId){
    //   //this.mode = "EDIT";
    //   this.readOnlyMode = true;
    //
    //   this.form.baseId = this.extensionBaseEntityId;
    //   this.form.masterId = this.masterId;
    // },

    async pinStickyNote() {
      if (this.entityInstance.id) {
        await Rpc.StickyNotes.addPinnedStickyNoteToBusinessEntity(this.formConfig.formClassLong, this.entityInstance.id, window.innerWidth - 305, 190);
      }
    },

    async showAuditLog() {
      let entityLabel = await FormsAI.getEntityLabel(this.formConfig, this.entityInstance);
      await ActivityManager.showActivity(AuditLog, {
        entityInstance: this.entityInstance,
        formClass: this.formConfig.formClassLong,
        entityLabel: entityLabel
      });
    },

    // app architect mode
    editConfigForm() {
      this.modeEditor = !this.modeEditor;
      this.renderers.forEach(renderer => {
        renderer.setEditorMode(this.modeEditor);
      });

      let lockedFields = []
      if (this.entityInstance?.__supplement__?.lockedFields) {
        lockedFields = this.entityInstance.__supplement__.lockedFields;
      }

      this.renderers.forEach(renderer => {
        if (lockedFields.includes(renderer.fieldConfig.fieldName) ||
            (renderer.fieldConfig.readOnlyInEdit && this.mode !== "NEW")) {
          return;
        }
      });
    },

    async deleteClick() {
      if (await FormsActions.delete(this.form.originalSource, true)) {
        this.form.markUnchanged();
        this.cancel();
      }
    },
    async saveAndClose() {
      try {
        this.saveInProgress = true;
        if (await this.save()) {
          let closeFormAfterInsertEntity = this.formConfig.closeFormAfterInsertEntity;
          if (!closeFormAfterInsertEntity && this.mode === "NEW") {
            let formConfig = this.formConfig;
            let id = this.entityInstance.id;
            this.reopen = async () => {
              setTimeout(async () => {
                    try {
                      if (id) {
                        await FormsActions.editEntity(formConfig, id);
                      } else {
                        let masterForm = this.masterFormModel ? this.masterFormModel : this.form;
                        masterForm.afterSave(async () => {
                          await FormsActions.editEntity(formConfig, id);
                        });
                      }
                    } finally {
                      ActivityManager.enableFade();
                    }
                  }
              )
            };
          }
          await this.close();
        }
      } finally {
        this.saveInProgress = false;
      }
    },
    async save() {
      try {
        this.saveInProgress = true;
        if (this.readOnlyMode) {
          return true;
        }
        this.entityInstance = await this.form.saveEntity(false, this.regionCode);
        this.pendingTranslations = this.entityInstance?.__supplement__?.translationInProgress;

        if (this.entityInstance.__supplement__) {
          this.entityInstance.__supplement__.translationInProgress = true;
        }
        if (!this.form.isValid || this.form.temporaryListsErrors) {
          setTimeout(() => {
            this.$emit("unsaved-changes");
          });
          DialogManager.infoHtml($tr('saveFailed', 'Save failed'), this.form.saveError).then();
          return false;
        }
        if (this.form.formConfig.reloadColumnsWhenDynamicsAreTab) {
          this.reloadDataForDynamic = !this.reloadDataForDynamic;
        }
        this.setReadOnly();
        this.form.setFieldsReadOnly(true, this.mode, this.fieldsManagedByParent);
        this.$emit('saved', this.entityInstance);

        return true;
      } catch (e) {
        if (e instanceof RpcInputValidationException) {
          let errorSummary = "";
          for (let fieldName in e.fields) {
            let field = e.fields[fieldName];
            if (field['errorMessage']) {
              errorSummary += field['errorMessage'] + "\n";
            }
          }
          if (e.errorMessage) {
            errorSummary += e.errorMessage;
          }

          await DialogManager.infoHtml($tr("entityEditForm.record.cant.save", "Record can't be saved"), errorSummary);
        } else {
          console.log(e);
        }
        return false;
      } finally {
        this.saveInProgress = false;
      }
    },
    /**
     * @return {FormModel}
     */
    getForm() {
      return this.form;
    },

    setReadOnly() {

      this.renderers.forEach(renderer => renderer.setReadOnly?.(true));
      if (this.inlineDetailsTab != null) {
        this.inlineDetailsTab.forEach(value => {
          this.$refs[value.detail.config.detailsClass + ":" + value.detail.config.joiningField][0]?.setReadOnly(true);
        });
      }
      this.readOnlyMode = true;
    },

    forEachRenderer(callback) {
      this.renderers.forEach(callback);
    },

    toggleArchitectMode(newState) {
      // console.log("mode: " + newState)
    },
    setEditorMode(val) {
      this.renderers.forEach(renderer => renderer.setEditorMode(val));
      this.modeEditor = val;
    },

    loadGallery() {
      if (this.entityInstance?.gallery && this.entityInstance.gallery.imagesList) {
        this.imagesList = [...this.entityInstance.gallery.imagesList];
      } else {
        this.imagesList = [];
      }
    },
    classInfo() {
      ActivityManager.showActivity(ClassInfo, {
        formConfig: this.formConfig,
        extensionConfig: this.extensionConfig
      }).then();
    },
    async loadAttachments() {
      if (this.entityInstance?.attachments) {
        this.attachmentsList = [...this.entityInstance.attachments];
      } else {
        this.attachmentsList = [];
      }

      for (let i = 0; i < this.attachmentsList.length; i++) {
        this.attachmentsList[i].data.sizeLabel = getFileSizeFormatter(this.attachmentsList[i].data.size);
      }
    },

    showProductPicture() {
      this.$emit("show-product-picture");
    },
    shoppingCartDemo() {
      window.open("https://splendi.pl/produkty/wirtualny-stylista-dla-zdjecia-uzytkownika/3/13336/", '_blank').focus();
    },
    aiDemo() {
      window.open("https://silkplm.com/wp-content/uploads/2024/06/SIMILARITY-RAPORT.pdf", '_blank').focus();
    },
    aiLab() {
      if (this.entityInstance?.aiInsight) {
        DialogManager.infoHtml("AI insight (base on main picture)", "<pre style='text-align: left;'>" + JSON.stringify(this.entityInstance.aiInsight, null, 2) + "</pre>");
      }
    }

  },

  props: {
    masterEntityInstance: {default: null},
    formConfig: {type: BaseFormConfig, required: true, default: null},
    entityId: {type: String, default: ""},
    mode: {type: String, required: true, default: null},
    readOnlyInputs: {type: Boolean, default: true},
    editorMode: {type: Boolean, default: false},
    entityInstanceLoaded: {type: Function},

    detailsConfig: {type: FormDetailsConfig, default: null},
    extensionConfig: {type: FormExtensionConfig, default: null},
    extensionBaseEntityId: {type: String, default: null},
    reloadDataForDynamicTab: {default: null},

    masterFormConfig: {type: BaseFormConfig, default: null},
    masterId: {type: String, default: null},
    masterFormModel: {type: FormModel, default: null},

    directParentFormModel: {type: FormModel, default: null},

    temporaryListToAdd: {type: TemporaryList, default: null},
    temporaryExtensionToSet: {type: TemporaryExtension, default: null},

    temporaryInstanceToEdit: {default: null},

    showHeader: {default: true},
    showFooter: {default: true},
    showFooterNavbar: {default: true},
    disableClose: {default: false},
    extensionId: {default: null},
    context: {default: null},
    isEntityInstance: {default: null},

    presetFields: {default: null},
    showDelete: {default: true},
    embedded: {default: false},
    customStyleForFluidContainer: {default: ""},
    editAfterStart: {default: false},
    inlineDetails: {default: () => []},
    showStickyNote: {default: false},
    toolboxMixins: {type: Array, default: () => []},
    fieldsFilter: {default: null},
  },

  watch: {
    inlineDetailsTab(newVal) {
      if (newVal && newVal.length) {
        this.$nextTick(() => {
          newVal.forEach(value => {
            const refName = value.detail.config.detailsClass + ':' + value.detail.config.joiningField;
            const ref = this.$refs[refName];
            if (ref && ref[0]) {
              ref[0].setReadOnly(this.readOnlyMode);
            }
          });
        });
      }
    },

    entityInstance: function (val) {
      this.isSendInquiry = this.entityInstance?.isSendInquiry;
      if (this.entityInstance?.isSendInquiry && this.sendOfferButton && !this.entityInstance?.supplierIdRemovedAndBlockedRoleSupplier) {
        this.sendOfferButton.disabled = true;
        this.sendAttachmentsButton.disabled = false;
      } else if (this.sendOfferButton && this.sendOfferButton !== null && !this.entityInstance?.supplierIdRemovedAndBlockedRoleSupplier) {
        this.sendOfferButton.disabled = false;
        this.sendAttachmentsButton.disabled = true;
      }
      if ((this.mode === "NEW" && this.sendOfferButton) || this.entityInstance?.supplierIdRemovedAndBlockedRoleSupplier) {
        this.sendOfferButton.disabled = true;
        this.sendAttachmentsButton.disabled = true;
      }
    },
    downloadingBrandingZip: function (val) {
      this.$emit("update:downloadingBrandingZip", this.downloadingBrandingZip);
    },
    'validatedField': function (val) {
      this.loadAttachments();
      this.loadGallery();
    },
    'validatedField.value': function (val) {
      this.loadAttachments();
      this.loadGallery();
    },

    readOnlyInputs: function (val) {
      this.readOnlyMode = val;
      this.renderers.forEach(renderer => renderer.setReadOnly(val));
      this.form.setFieldsReadOnly(val, this.mode, this.fieldsManagedByParent);
      this.form.refreshVisibilityOfReadOnly();
    },

    editorMode: function (val) {
      this.modeEditor = val;
      this.renderers.forEach(renderer => renderer.setEditorMode(val));
    },

    readOnlyMode: async function (val) {
      if (this.formConfig.formClassLong === await Dimensions.getRemoteClass() && val) {
        let cloneButton = this.toolbox.find(value => value.label === this.cloneButtonLabelText);
        cloneButton.disabled = true;
      } else if (this.formConfig.formClassLong === await Dimensions.getRemoteClass() && !val) {
        let cloneButton = this.toolbox.find(value => value.label === this.cloneButtonLabelText);
        cloneButton.disabled = false;
      }
      if (this.form) {
        this.form.readOnlyMode = val;
        for (let [fieldLabel, field] of Object.entries(this.form.fields)) {
          field.validatedForm.readOnlyMode = val;
        }
      }
      this.$emit("read-only-mode-change", val);
    },

    inlineDetails: function (val) {
      if (val && val.length) {
        this.injectInlines(val);
      }
    },

    reloadDataForDynamic: function (val) {
      this.$emit("update:reloadDataForDynamicTab", this.reloadDataForDynamic);
    },
  },

  data: function () {
    let toolbox = [];
    let classMixins = getCustomToolboxMixinsForList(this.formConfig, this);
    this.cloneButtonLabelText = $tr('entityEdit.cloneData', 'Clone data from another Dimension Tab');
    if (this.formConfig.showProductInfoBranding) {
      let brandingButton = new ToolboxButton().withIcon("table").withLabel($tr('productBrandingInfo', 'Product Branding Info')).withGroup("A")
          .setToggleType().withToggled(false).withToggle(async () => EntityEditFormService.collectDataFromProductToBranding(this.entityId));
      toolbox.push(brandingButton);
    }
    if (this.entityId && this.formConfig.formClassLong === Order.getRemoteClass()) {
      let exportBrandingZipButton = new ToolboxButton().withIcon("folder-arrow-down").withLabel($tr("exportBrandingFolder", "Export Branding Folder"))
          .withAction(() => EntityEditFormService.exportBrandingFolderForOrder(this.entityInstance, this.entityId, this.downloadingBrandingZip));
      toolbox.push(exportBrandingZipButton);
    }
    if (this.formConfig.formClassLong === Dimensions.getRemoteClass()) {
      let updateProductDynamicAttributesButton = new ToolboxButton().withIcon("clone")
          .withLabel(this.cloneButtonLabelText).withDataTestPath('clone-dimensions-btn').withAction(() => {
            cloneDataFromAnotherDimensionsTab(this.masterFormConfig.formClassLong, this.masterFormModel.originalSource.id)
          });
      toolbox.push(updateProductDynamicAttributesButton);
    }

    /*
    TODO:
    1. zobaczyć czy to się powinno zawsze wyświetlać zależenie od uprawnień
    2. zobaczyć jak się zachowa dla dynamicznych
    3. kopiowanie list zagniezdzonych
    4. dodac do dialogu liste uniqów do wypełnienia, bo inaczej sie nie zapisze
     */

    if (this.formConfig.printouts) {
      for (let printoutClazz in this.formConfig.printouts) {
        let flags = this.formConfig.enabledPrintoutsByFeatureFlags;
        if (flags?.length) {
          let printoutEnabled = checkIfEnabledByFeatureFlags(flags);
          if (!printoutEnabled) {
            break;
          }
        }
        let label = "";
        if (this.formConfig.printouts[printoutClazz].includes("Printout")) {
          label = this.formConfig.printouts[printoutClazz];
        } else {
          label = this.formConfig.printouts[printoutClazz] + " Printout";
        }
        const clazz = this.formConfig.formClassLong;
        const formattedClazz = clazz.replace(/ /g, '.');
        // TODO wojtek dorobić dynamiczne Tr'y
        let printButton = new ToolboxButton().withIcon("print").withLabel(label).withDataTestPath(label.replace(" ", "_")).withAction(async () => {
          await PrintoutManager.formPrintout(this.formConfig, printoutClazz, this.entityInstance);
        });
        toolbox.push(printButton);
        break;
      }
    }
    if (SessionManager.hasFlag(FeatureFlag.CONTRACTORS_MARKET)) {
      if (this.formConfig.formClassLong === PlanningProduct.getRemoteClass() || this.formConfig.formClassLong === PPSamplesProduct.getRemoteClass()) {
        this.sendOfferButton = new ToolboxButton().withIcon("fa-paper-plane").withGroup("g-send").withDisabled(this.isSendInquiry)
            .withLabel(this.formConfig.formClassLong === PlanningProduct.getRemoteClass() ? $tr('sendInquiry',
                    'Send Offer Inquiry and attachment with Project Specification') :
                $tr('orderSample', 'Order Sample')).withDataTestPath('multiedit-attributes-btn').withAction(async (btn) => {
              // let confirmed = await DialogManager.yesNo($tr('sendOffer', 'Send offer'),
              //     $tr('entitiesList.sendOffer', 'Would you like to send the offer'), false);

              let confirmed;
              let supplierToSendTo = this.entityInstance.supplierId;
              // if ()
              if (this.formConfig.formClassLong === await PlanningProduct.getRemoteClass()) {
                confirmed = await DialogManager.yesNo($tr('sendOfferFromMotherCompany',
                        'Send Offer Inquiry and attachment with Project Specification'),
                    $tr('entitiesList.sendOfferInquiryFromMotherCompany',
                        'Would you like to send the Offer Inquiry and attachment with Project Specification?'));

              } else {
                confirmed = await DialogManager.yesNo($tr('sendSampleFromMotherCompany', 'Order Sample'),
                    $tr('entitiesList.sendSampleFromMotherCompany', 'Would you like to order the Sample?'));
              }

              let supplierIsRemoved = await Rpc.plm.services.marketPlace.services.roleSupplierCheckbox.SupplierRoleCheckboxChangeService.checkIfCanBeSend(supplierToSendTo);
              if (!supplierIsRemoved) {
                if (confirmed && this.formConfig.formClassLong === await PlanningProduct.getRemoteClass()) {
                  await prepareToSendMarkedEntity([this.entityInstance], "planningProduct");
                } else {
                  await prepareToSendMarkedEntity([this.entityInstance], "PPSamplesProduct");
                }
              } else {
                if (this.formConfig.formClassLong === await PlanningProduct.getRemoteClass()) {
                  await DialogManager.info(
                      $tr("pupNotification.supplierRoleBlocked.cantSendOffer.header",
                          "You cannot send the Offer Inquiry because you have blocked this Supplier."),
                      $tr("pupNotification.supplierRoleBlocked.cantSendInquiry.body",
                          "You cannot send the Offer Inquiry because you have removed the Supplier role from this Contractor."))
                } else {
                  await DialogManager.info(
                      $tr("pupNotification.supplierRoleBlocked.cantSendSample.header",
                          "You cannot order the Sample because you have blocked this Supplier."),
                      $tr("pupNotification.supplierRoleBlocked.cantSendSample.body",
                          "You cannot order the Sample because you have removed the Supplier role from this Contractor.")
                  )
                }
                // await Rpc.plm.services.marketPlace.services.SupplierRoleCheckboxChangeService.popupNotificationCantBeSend();
              }
            });
        toolbox.push(this.sendOfferButton);


        this.sendAttachmentsButton = new ToolboxButton().withIcon("fa-solid fa-envelopes-bulk").withGroup("g-send").withDisabled(!this.isSendInquiry)
            .withLabel(this.formConfig.formClassLong === PlanningProduct.getRemoteClass() ? $tr('resendInquiry',
                'Resend the attachment with Project Specification') : $tr('sendReportSample',
                'Send an attachment with a report that includes comments after evaluating the Sample'))
            .withDataTestPath('multiedit-attributes-btn').withAction(async (btn) => {
              let titleDialogManager = "";
              let bodyDialogManager = "";

              if (this.formConfig.formClassLong === PlanningProduct.getRemoteClass()) {
                titleDialogManager = $tr('sendAttachment.inquiry.form',
                    'Resend the attachment with Project Specification');
                bodyDialogManager = $tr('entitiesList.send.attachment.inquiry',
                    'Would you like to resend the attachment with Project Specification?');
              } else {
                titleDialogManager = $tr('sendAttachment.sample.form',
                    'Send an attachment with a report that includes comments after evaluating the Sample');
                bodyDialogManager = $tr('entitiesList.send.attachment.sample',
                    'Would you like to send an attachment with a report that includes comments after evaluating the Sample?');
              }

              let confirmed = await DialogManager.yesNo(titleDialogManager, bodyDialogManager, false);
              if (confirmed) {
                await resendAttachments([this.entityInstance], this.formConfig.formClassLong === PPSamplesProduct.getRemoteClass());
              }
            });
        toolbox.push(this.sendAttachmentsButton);

      }
    }


    if (SessionManager.hasFlag(FeatureFlag.CLONE_OBJECTS) && this.formConfig.canClone) {
      let cloneButton = new ToolboxButton().withIcon("clone").withLabel($tr("clone", "Clone"))
          .withAction(() => EntityEditFormService.cloneEntity(this.entityInstance, this.entityId));
      toolbox.push(cloneButton);

      if (this.formConfig.canChain) {
        let graphButton = new ToolboxButton().withIcon("diagram-project").withLabel($tr("showVersions", "Show versions"))
            .withAction(() => EntityEditFormService.showGraph(this.entityInstance, this.entityId));
        toolbox.push(graphButton);
      }
      if (this.entityId && this.formConfig.formClassLong === ProductInSeason.getRemoteClass()) {
        let orderNumberFormFieldConfig = _.find(this.formConfig.fields, {fieldName: "orderNumber"});
        let orderNumberFieldEnabled = checkIfEnabledByOrganizationFormsSettingsForFormField(this.formConfig, orderNumberFormFieldConfig);
        if (orderNumberFieldEnabled) {
          let generateOrderNumberButton = new ToolboxButton().withIcon("circle-1").withLabel($tr("generateOrder", "Generate Order Number"))
              .withAction(() => EntityEditFormService.generateOrderNumber(this.formConfig, this.form, this.entityInstance)).withGroup("D").withDisabled(false);
          toolbox.push(generateOrderNumberButton);
        }
      }
    }


    let dummy = [];
    if (window['demo'] && this.formConfig?.formClassLong === "com.silkplm.model.plm.ProductInSeason") {
      dummy = [
        new ToolboxButton().withIcon("fa-duotone fa-wand-magic-sparkles").withLabel($tr("ai", "AI")).withGroup("demo").withAction(() => this.aiDemo()),
        new ToolboxButton().withIcon("cart-shopping").withLabel($tr("ecommerce", "E-Commerce")).withGroup("demo").withAction(() => this.shoppingCartDemo())
      ]
    }

    let lab = [];
    let aiFeatures = [];

    if (SessionManager.hasFlag(featureFlag.AI_VIRTUAL_STYLIST)) {
      aiFeatures = [
        new ToolboxButton().withIcon("fa-equals").withLabel($tr("similarProducts", "Similar Products")).withGroup("demo").withAction(() => FormsActions.showList(SimilarProductsInSeason)),
        new ToolboxButton().withIcon("fa-waves-sine").withLabel($tr("matchedProducts", "Matched Products")).withGroup("demo").withAction(() => FormsActions.showList(MatchedProductsInSeason))
      ]
    }
    if (SessionManager.hasFlag(featureFlag.AI_GENERATION_AND_VISUALIZATION)) {
      if (this.formConfig?.formClassLong === "com.silkplm.model.plm.Marketing" && !SessionManager.isProd()) {
        lab = [
          new ToolboxButton().withIcon("fa-duotone fa-wand-magic-sparkles").withLabel($tr("generateAll", "Generate All")).withGroup("demo").withAction(async () => {
                let makeSure = true;
                if (this.form.validatedFieldByName("reachDescription").value ||
                    this.form.validatedFieldByName("productAdvertise").value ||
                    this.form.validatedFieldByName("useRecommendation").value ||
                    this.form.validatedFieldByName("keywords").value ||
                    this.form.validatedFieldByName("hashtags").value ||
                    this.form.validatedFieldByName("shortDescription").value) {
                  makeSure = await DialogManager.yesNo($tr('entity-edit-desc-override-ai', 'Overriding values'),
                      $tr('entity-edit-desc-override', 'Do you like to override all marketing descriptions with new AI generated values?'))
                }

                if (makeSure) {
                  DialogManager.openPendingDialog($tr("marketing-generating", "Generating"));
                  let productInSeasonId = this.form.validatedFieldByName('productInSeasonId').value;
                  let productInSeason = new ProductInSeason();
                  await productInSeason.load(productInSeasonId);
                  let image = productInSeason.gallery.imagesList.filter(element => element.customData?.imageTagList.some(x => x.name === "Main Picture"));

                  let task = await Rpc.ai.GenerateDescriptionByAI.getImageDescriptionByAiV2(SessionManager.defaultCustomerLanguageCode, "", image[0], false);
                  let descriptionAI = await task.finish();

                  this.form.validatedFieldByName("shortDescription").value = descriptionAI["title"];
                  this.form.validatedFieldByName("reachDescription").value = descriptionAI["description"];
                  this.form.validatedFieldByName("productAdvertise").value = descriptionAI["content"];
                  this.form.validatedFieldByName("useRecommendation").value = descriptionAI["usage"];
                  this.form.validatedFieldByName("hashtags").value = descriptionAI["hashtags"];
                  this.form.validatedFieldByName("keywords").value = descriptionAI["keywords"];
                }
                DialogManager.closePendingDialog();
              }
          ),
        ]
      }
    }

    if (this.formConfig.formClassLong === Order.getRemoteClass()) {
      let exportBrandingZipButton = new ToolboxButton()
          .withDisabled(false)
          .withIcon("file-arrow-down")
          .withLabel($tr("entityEditForm.orderDetailsPrintout2", "Order – Excel Printout"))
          .withAction(async () => {
            this.language = localStorage.getItem("printout.language") || SessionManager.defaultInterfaceLanguageCode || "en";
            this.shouldRemember = true;
            let result = await EntityEditFormService.orderDetailsPrintoutRawMaterialsPath(
                this.entityInstance,
                this.language,
                this.shouldRemember
            );
            if (result.shouldRemember) {
              this.language = result.language;
              this.shouldRemember = result.shouldRemember;
              localStorage.setItem('printout.language', this.language);
            }
          });
      toolbox.push(exportBrandingZipButton);
    }
    return {
      regionCode: 'def',
      downloadingBrandingZip: {val: false, error: false},
      translationsEnabled: null,
      interfaceTranslationsEnabled: null,
      isSendInquiry: false,
      editEnabled: true,
      nothingFound: $tr('entity-edit-form-nothing-found', 'Nothing Found'),
      canDelete: true,
      mixinsElements: [],
      readyToShow: false,
      hideDeleteByForm: false,
      inlinesConstructed: false,
      inlinesInjected: false,
      inlineDetailsTab: [],
      SAVE_AND_CLOSE_LABEL: $tr("Save", "Save"),
      RETRY_ADD_AND_CLOSE_LABEL: $tr("retry-add-button", "Retry Add"),
      ADD_AND_CLOSE_LABEL: $tr("add", "Add"),
      entityInstance: null,
      pendingTranslations: false,
      readOnlyMode: false,
      modeEditor: false,
      partiallySavedNew: false,
      hiddenTab: false,
      reloadDataForDynamic: false,
      permissions: new PermissionsSet(),
      language: null,
      isDev: !SessionManager.isProd(),
      saveInProgress: false,

      /** DataEntity */
      entity: null,

      /** @type{FormModel} */
      form: null,
      fieldsManagedByParent: {},
      multicolumn: false,
      toolbox: [
        ...toolbox,
        ...this.toolboxMixins,
        new ToolboxButton().withIcon("wrench").withLabel($tr("formSettings", "Form Settings")).withGroup("A").setToggleType().withToggled(false)
            .withToggle(() => this.editConfigForm()).withRequiredPermission("APPLICATION_ARCHITECT"),
        new ToolboxButton().withIcon("gear-code").withLabel($tr("formSettings", "Form Settings")).withGroup("A")
            .withAction(() => this.classInfo()).withRequiredPermission("APPLICATION_ARCHITECT"),

        // new ToolboxButton().withIcon("user").withLabel("XXX").withAction((btn) => console.log("mode: " + this.mode)),
        // new ToolboxButton().withIcon("recycle").withLabel("Recycle").withGroup("A"),
        // new ToolboxButton().withIcon("recycle").withLabel("Recycle"),
        // new ToolboxButton().withIcon("recycle").withLabel("Recycle").withGroup("B"),

        ...dummy,
        ...lab,
        ...aiFeatures,
        ...classMixins,
      ],

      imagesList: [],
      listOfImagesInGalleryCard: [],
      numberOfImages: 0,
      attachmentsList: [],
      firstPageLoad: 0,
      editEnabledBySecuredFields: false,
      hasLeftDock: false,
      dockedInputRows: null,
      dockStyle: 'col-12 m-0 col-md-6 m-md-r-2'
    };
  }
}
</script>